import { Link } from 'react-router';

export default function Landing() {
  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center gap-6 p-8 text-center">
      <h1 className="text-4xl font-bold tracking-tight">planb</h1>
      <p className="text-lg text-gray-600">
        Guided business plans for entrepreneurs — structured, hosted, and drafted with you.
      </p>
      <div className="flex gap-4">
        <Link
          to="/register"
          className="rounded-md bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          Get started
        </Link>
        <Link
          to="/login"
          className="rounded-md border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
        >
          Sign in
        </Link>
      </div>
    </main>
  );
}
